import { httpEnrollmentClient } from '@/services/common/httpClient';
import { SetupIntentRequest, SetupIntentResponse } from '@/Model/stripe/types';
import { SubmitOrderRequest, SubmitOrderResponse } from '@/Model/checkout/cart/types';
import API_CONST from '@/constants/ApiConst';

export function createSetupIntent(payload: SetupIntentRequest) {
  return httpEnrollmentClient().post<SetupIntentResponse>(API_CONST.STRIPE_SETUP_INTENT, payload);
}

export function submitOrder(payload: SubmitOrderRequest) {
  return httpEnrollmentClient().post<SubmitOrderResponse>(API_CONST.CART_SUBMIT, payload);
}